import { Switch } from '@optiaxiom/react';

import { ToolsTableRow } from '../types';

export default function ChatEnabledStatusCell({
  toolRow,
  onToggleEnabledInPrimaryAgent,
}: {
  toolRow: ToolsTableRow;
  onToggleEnabledInPrimaryAgent: (toolName: string, isEnabledInPrimaryAgent: boolean) => void;
}) {
  if (toolRow.isRegistry) return null;

  return (
    <Switch
      disabled={toolRow.tool.is_disabled}
      checked={toolRow.tool.is_enabled_in_primary_agent}
      onCheckedChange={() =>
        onToggleEnabledInPrimaryAgent(toolRow.tool.name, toolRow.tool.is_enabled_in_primary_agent)
      }
      aria-label={`Toggle ${toolRow.tool.name} enabled in primary agent`}
    />
  );
}
